import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  mode:"history",
  routes: [
    {
      path: '/404',
      component: () => import( '../view/error.vue'),
      hidden: true
    }, 
    {
      path: '/',
      // name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/Mandarin'
        }, 
        {
          path: '/Mandarin',
          name: 'Mandarin',
          component: resolve => require(['@/view/index'], resolve),
          meta: {
            title: '首页'
          }
        }, {
          path: '/PTC',
          name: 'PTC',
          component: resolve => require(['@/view/PTC'], resolve),
        },
        {
          path: '/SCTT',
          name: 'SCTT',
          component: resolve => require(['@/view/SCTT'], resolve),
        },
        {
          path: '/privacy-notice',
          name: 'privacyNotice',
          component: resolve => require(['@/view/privacyNotice'], resolve),
        },
      ]
    }, 
    { path: '*',
      redirect: '/404', 
      hidden: true 
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js